/* The long home page (19 Sep, Kaitlin: "billboard, then newspaper, then something… 10x longer with more CTA").
   Loaded by several sections, runs once:
   1. Hero example (snippets/me-hero-drop.liquid): cycles the real renders and changes the headline's italic line
      with them ("a real billboard." → "a newspaper." …). Stops once they've dropped a logo.
   2. [data-reveal]: fades things up as they scroll in.
   3. Floating "Start creating" (sections/me-v-sticky.liquid): shows after the hero, hides over the last section. */
(function () {
  if (window.mxHomeLong) { return; }
  window.mxHomeLong = true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Where the design lands in each photo, as a fraction of the photo: left, top, right, bottom. Measured from a
     solid-magenta render of each template (19 Sep); the matching outline is assets/me-area-<name>.png. */
  var AREAS = {
    'me-row-vertical-city-billboard': [0.480, 0.151, 0.788, 0.583],
    'me-row-newspaper-heritage-building-01': [0.214, 0.160, 0.792, 0.623],
    'me-row-large-shopping-bag-puddle': [0.262, 0.402, 0.693, 0.763],
    'me-row-macbook-boucle-couch-01': [0.278, 0.174, 0.876, 0.490],
    'me-row-torn-street-poster': [0.290, 0.336, 0.993, 0.714],
    'me-row-iphone-in-jeans': [0.483, 0.297, 0.833, 0.621]
  };

  /* Outline the design area on the showing photo, then let the photo speak for itself. */
  function highlight(fig, slide) {
    var area = fig.querySelector('[data-hd-area]'), label = fig.querySelector('[data-hd-area-label]');
    var box = AREAS[slide.getAttribute('data-row')];
    clearTimeout(fig._hdOff);
    if (!area) { return; }
    area.classList.remove('is-on');
    if (label) { label.classList.remove('is-on'); }
    if (!box) { return; }
    area.src = slide.getAttribute('data-area');
    area.hidden = false;
    /* Same object-fit: cover maths as the photo, so the label sits on the area whatever the frame's shape. */
    function place() {
      if (!label || !slide.naturalWidth) { return; }
      var W = fig.clientWidth, H = fig.clientHeight, nw = slide.naturalWidth, nh = slide.naturalHeight;
      var k = Math.max(W / nw, H / nh), ox = (W - nw * k) / 2, oy = (H - nh * k) / 2;
      var cx = ox + (box[0] + box[2]) / 2 * nw * k, top = oy + box[1] * nh * k, bottom = oy + box[3] * nh * k;
      label.hidden = false;
      var lw = label.offsetWidth, lh = label.offsetHeight;
      var y = top - lh - 8;
      if (y < 52) { y = Math.min(bottom + 8, H - lh - 44); }  /* no room above (the file chip is there): go below */
      label.style.left = Math.max(8, Math.min(W - lw - 8, cx - lw / 2)) + 'px';
      label.style.top = Math.max(8, y) + 'px';
    }
    setTimeout(function () {
      place();
      area.classList.add('is-on');
      if (label) { label.classList.add('is-on'); }
    }, 450);
    fig._hdOff = setTimeout(function () {
      area.classList.remove('is-on');
      if (label) { label.classList.remove('is-on'); }
    }, 2900);
  }

  function cycle(fig) {
    if (fig.dataset.cycling) { return; }
    fig.dataset.cycling = '1';
    var slides = fig.querySelectorAll('.mv-hd__slide');
    if (slides.length) { highlight(fig, slides[0]); }
    if (slides.length < 2) { return; }
    var hero = fig.closest('.mv-hero'), box = fig.closest('[data-try]');
    var word = hero && hero.querySelector('[data-hd-word]');
    var chip = fig.querySelector('[data-hd-chip]'), chipName = fig.querySelector('[data-hd-chip-name]');
    var i = 0;
    /* Warm the next photos so the swap never shows a blank. */
    Array.prototype.forEach.call(slides, function (s) { s.loading = 'eager'; });
    setInterval(function () {
      if (document.hidden || (box && box.classList.contains('has-art'))) { return; }
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      var s = slides[i];
      s.classList.add('is-on');
      highlight(fig, s);
      if (chip && s.getAttribute('data-chip')) { chip.src = s.getAttribute('data-chip'); }
      if (chipName) { chipName.textContent = s.getAttribute('data-chip-name') || ''; }
      if (word && s.getAttribute('data-word')) {
        word.classList.remove('is-swap'); void word.offsetWidth;
        word.textContent = s.getAttribute('data-word');
        if (!reduced) { word.classList.add('is-swap'); }
      }
    }, 3600);  /* was 2600: long enough to see the outline, then the photo clean */
  }

  function reveal(root) {
    var els = root.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduced) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(els, function (e) { e.classList.add('mv-reveal'); io.observe(e); });
  }

  function sticky() {
    var bar = document.querySelector('[data-sticky-cta]');
    if (!bar || !('IntersectionObserver' in window)) { return; }
    var hero = document.querySelector('.mv-hero'), last = document.querySelector('.mv-final');
    var pastHero = false, atEnd = false;
    function paint() { var on = pastHero && !atEnd; bar.hidden = false; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); }
    if (hero) { new IntersectionObserver(function (en) { pastHero = !en[0].isIntersecting; paint(); }).observe(hero); }
    if (last) { new IntersectionObserver(function (en) { atEnd = en[0].isIntersecting; paint(); }).observe(last); }
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hd-cycle]'), cycle);
    reveal(document);
    sticky();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); Array.prototype.forEach.call(e.target.querySelectorAll('[data-hd-cycle]'), cycle); });
})();
